import apiClient from "./client";
import type {
  GetOrganizationsParams,
  OrganizationsListResponse,
} from "../types/organization";

export const getOrganizations = async (
  params: GetOrganizationsParams
): Promise<OrganizationsListResponse> => {
  const { data } = await apiClient.get<OrganizationsListResponse>(
    "/organizations",
    { params }
  );
  return data;
};
